import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import { Notification, MessageBox, Message, Loading } from "element-ui";
import { getCookie } from "@/utils/common";

// const login = () => import("../views/login/login.vue"); // 登录
// const fillHome = () => import("../views/fill/fill_home.vue"); // 首页
const newFillHome = () => import("../views/fill/newFill_home.vue"); // 首页
const fillIndex = () => import("../views/fill/fill_index.vue"); // 模拟填报
const fillSchool = () => import("../views/fill/fill_school.vue"); // 查院校
const fillSpeciality = () => import("../views/fill/fill_speciality.vue"); // 查专业
const fillOptional = () => import("../views/fill/fill_optional.vue"); // 选科系统
const fillSpecial = () => import("../views/fill/fill_special.vue"); //专题
const fillPaper = () => import("../views/fill/fill_paper.vue"); //查试卷
const fillSearch = () => import("../views/fill/fill_search.vue"); //首页搜索
const fillNews = () => import("../views/fill/fill_news.vue"); //高校新闻
const fillConstitution = () => import("../views/fill/fill_constitution.vue"); //招生章程

const volunteerForm = () => import("../views/fill/volunteer_form.vue"); // 志愿表
const exportedTable = () => import("../views/fill/exported_table.vue"); // 预览志愿表(已废弃)
const payIndex = () => import("../views/pay/pay_index.vue"); // 支付

const schoolIndex = () => import("../views/school/school_index.vue"); //学校首页
const majorIndex = () => import("../views/school/major_index.vue"); //专业首页
const schoolFile = () => import("../views/school/file.vue"); //文件查看页
const schoolArticle = () => import("../views/school/article.vue"); //文章详情页
const specialSubject = () => import("../views/school/special_subject.vue"); //专题详情页
const contact = () => import("../views/school/contact_index.vue"); //联系我们
const weixin=()=> import("../views/school/weixin_index.vue"); //微信登录

Vue.use(VueRouter);

const routes = [
  {
    //找不到路由时跳转的页面
    path: "*",
    name: "newFillHome",
    component: newFillHome,
  },
  // {
  //   path: "/",
  //   name: "login",
  //   component: login,
  // },
  {
    path: "/",
    name: "newFillHome",
    component: newFillHome,
  },
  {
    path: "/fill/fill_school",
    name: "fill_school",
    component: fillSchool,
  },
  {
    path: "/fill/fill_search",
    name: "fill_search",
    component: fillSearch,
  },
  {
    path: "/fill/fill_news",
    name: "fill_news",
    component: fillNews,
  },
  {
    path: "/fill/fill_constitution",
    name: "fill_constitution",
    component: fillConstitution,
  },
  {
    path: "/fill/fill_speciality",
    name: "fill_speciality",
    component: fillSpeciality,
  },
  {
    path: "/fill/fill_special",
    name: "fill_special",
    component: fillSpecial,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/fill/fill_optional",
    name: "fill_optional",
    component: fillOptional,
    // meta: {
    //   keepAlive: true, //此页面需要缓存
    // },
  },
  {
    path: "/fill/fill_index",
    name: "fill_index",
    component: fillIndex,
    // meta: {
    //   keepAlive: true, //此页面需要缓存
    // },
  },
  {
    path: "/fill/fill_paper",
    name: "fill_paper",
    component: fillPaper,
  },
  {
    path: "/fill/volunteer_form",
    name: "volunteer_form",
    component: volunteerForm,
  },
  {
    path: "/fill/exported_table",
    name: "exported_table",
    component: exportedTable,
  },

  {
    path: "/pay/pay_index",
    name: "pay_index",
    component: payIndex,
  },
  {
    path: "/school/school_index",
    name: "school_index",
    component: schoolIndex,
    // meta: {
    //   keepAlive: true, //此页面需要缓存
    // }
  },
  {
    path: "/school/major_index",
    name: "major_index",
    component: majorIndex,
  },
  {
    path: "/school/file",
    name: "school_file",
    component: schoolFile,
  },
  {
    path: "/school/article",
    name: "school_article",
    component: schoolArticle,
  }, 
  {
    path: "/school/special_subject",
    name: "special_subject",
    component: specialSubject,
  },
  {
    path: "/school/contact",
    name: "contact",
    component: contact,
  },
  {
    path: "/school/weixin",
    name: "weixin",
    component: weixin,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      //解决页面从列表页跳转到详情页返回,初始在原来位置
      return savePosition;
    } else {
      //解决页面跳转后页面高度和前一个页面高度一样
      return { x: 0, y: 0 };
    }
  },
});

//设置全局路由守卫，路由跳转前的判断：
router.beforeEach((to, from, next) => {
  console.log(store.state, "vuex数据");
  //除了login和register，其他的路由访问必须先登录
  let tokenIsExists = store.state.user.token ? true : false; //检查本地存储中是否有token

  const detectDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // 检测是否是手机
    if (/android/i.test(userAgent) || /iPhone|iPad|iPod/i.test(userAgent)) {
      return "手机";
    }
    // 检测是否是浏览器
    if (/Chrome|Firefox|Safari|Opera|Edge/i.test(userAgent)) {
      return "浏览器";
    }
    return "未知设备";
  };
  let device = false;

  if (detectDevice() === "手机" && to.matched[0].meta.requiresAuth === true) {
    device = true;
  } else {
    device = false;
  }

  if (tokenIsExists || device) {
    console.log("已登录", to);
    //定位到顶部
    // 兼容chrome
    document.body.scrollTop = 0;
    // 兼容firefox
    document.documentElement.scrollTop = 0;
    //token存在的情况下，对个别跳转到的页面的处理
    //登录页跳过权限判断
    if (to.path == "/") {
      next();
      // Message({
      //   message: '欢迎回来',
      //   type: 'success'
      // })
      return;
    } else {
      next();
    }
  } else {
    if (to.path == "/") {
      //token不存在的情况下,即不需要登录的页面：
      console.log("未登录");
      next();
    } else {
      if (getCookie("isTourist") == 0) {
        next();
      } else {
        next('/')
      }
    }
  }
});

//防止路由重复点击报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
